import { createPortal } from 'preact/compat'
import Icon from '@/components/snippets/icon/icon'

export const SearchHeader = ({ query, corrections, totalResults }) => {
  const searchHeader = document.querySelector('#search-results')

  if (!searchHeader) {
    return null
  }

  const focusSearch = (containerId) => {
    const searchContainer = document.querySelector(`#${containerId} input[name="query"]`)
    if (searchContainer) {
      setTimeout(() => {
        searchContainer.focus()
      }, 100)
    }
  }

  const hasDidYouMean = !!corrections?.didYouMean
  const primaryMessage = `No Results For "${corrections?.corrected || query}"`

  return createPortal(
    <div className="flex flex-col items-center justify-between gap-x-1 w-full min-h-[56px] lg:min-h-[55px] px-margin border-b border-borders-default" data-results={totalResults}>
      <div className="flex items-center lg-max:justify-between gap-x-1 w-full">
        <div className="flex items-center gap-x-1 py-1">
          <div className="lg:pr-1 lg:border-r lg:border-borders-default">
            <h2 className="paragraph-m font-serif italic">
              {primaryMessage}
            </h2>
          </div>
          {hasDidYouMean && (
            <div className="richtext paragraph-xs pr-1 lg:border-r border-borders-default">
              <p>Did you mean: <a href={`/search?query=${corrections.didYouMean}`} aria-label={`Search for ${corrections.didYouMean}`}>{corrections.didYouMean}</a></p>
            </div>
          )}
        </div>
        <div className="py-0.25">
          <x-button class="btn btn-text btn-primary btn-m w-fit" data-modal-parent="quick-search" data-modal-role="open" aria-label="Search Again" onClick={() => focusSearch('quick-search')}>
            <div className="flex size-[13px] children:size-full">
              <Icon id="magnifying-glass" />
            </div>
            <span>
              Search<span className="hidden md:inline"> Again</span>
            </span>
          </x-button>
        </div>
      </div>
    </div>,
    searchHeader
  )
}
